import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: 'var(--space-8) var(--space-4)',
  },
  icon: {
    color: 'var(--text-tertiary)',
    fontSize: 32,
    marginBottom: 'var(--space-3)',
    display: 'flex',
  },
  title: {
    fontSize: 14,
    fontWeight: 600,
    color: 'var(--text)',
  },
  hint: {
    fontSize: 13,
    color: 'var(--text-secondary)',
    marginTop: 4,
    maxWidth: 320,
  },
  action: {
    marginTop: 'var(--space-4)',
  },
}));

/** Centered icon/title/hint/CTA pattern for empty tables and lists (docs/DESIGN_MAKEOVER.md 4.3). */
const EmptyState = ({ icon, title, hint, action }) => {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      {icon ? <span className={classes.icon}>{icon}</span> : null}
      {title ? <Typography className={classes.title}>{title}</Typography> : null}
      {hint ? <Typography className={classes.hint}>{hint}</Typography> : null}
      {action ? <Box className={classes.action}>{action}</Box> : null}
    </Box>
  );
};

export default EmptyState;
